import { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { RootState } from '@/store/index';
import CertificateView from './view';

import { listOfUiForCertificates } from "@/pages/timeline/sections/timeline/timelineSections/certificate/constants";

import InEligibleNotice from '@/pages/timeline/sections/timeline/timelineSections/certificate/diffUi/inEligibleNotice'
import PaymentPendingNotice from '@/pages/timeline/sections/timeline/timelineSections/certificate/diffUi/paymentPendingNotice'
import VerificationPending from '@/pages/timeline/sections/timeline/timelineSections/certificate/diffUi/verificationPending'
import ExamPending from '@/pages/timeline/sections/timeline/timelineSections/certificate/diffUi/examPending'
import ExtendDuration from '@/pages/timeline/sections/timeline/timelineSections/certificate/diffUi/extendDuration'
import NocVerificationPending from '@/pages/timeline/sections/timeline/timelineSections/certificate/diffUi/nocVerificationPending'
import CertificateReady from '@/pages/timeline/sections/timeline/timelineSections/certificate/diffUi/certificateReady'
import CertificateClaimed from '@/pages/timeline/sections/timeline/timelineSections/certificate/diffUi/certificateClaimed'
import CertificateDispatched from '@/pages/timeline/sections/timeline/timelineSections/certificate/diffUi/certificateDispatched'
import DeliveryConfirmed from '@/pages/timeline/sections/timeline/timelineSections/certificate/diffUi/deliveryConfirmed'

import ConfirmCertificateDeliveredModal from '@/components/timeline/confirmCertificateDeliveredModal'
import { verifyFieldNames } from '@/pages/timeline/sections/timeline/timelineSections/verify/constants';
import { keyForCodeForSection } from '@/pages/timeline/sections/timeline/timelineSections/constants';

import { claimCertificateApiCall, markCertificateReceivedApiCall } from '@/services/api'

import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import { toast } from 'sonner';

export default function Certificate(props: any) {
    const navigate = useNavigate();
    const { common } = useLocalTranslation();

    const timelineDetails = useSelector((state: RootState) => state.timelineReducer.timeline);
    const certificateUI = useSelector((state: RootState) => state.certificateUIReducer.certificateUI);

    const [renderUi, setRenderUi] = useState('')
    const [showModal, setShowModal] = useState(false);
    const [isCertificateBtnLoading, setIsCertificateBtnLoading] = useState(false);
    const [certificateErr, setCertificateErr] = useState("");

    useEffect(() => {
        handleWhichUiToRender()
    }, [certificateUI])


    const handleCertificateClaim = async () => {
        setIsCertificateBtnLoading(true)
        setCertificateErr("")
        const fieldsToUpdate = {
            purchaseId: timelineDetails.purchaseId
        }
        const claimCertificateApiCallStatus = await claimCertificateApiCall(fieldsToUpdate);
        if (claimCertificateApiCallStatus.status) {
            handleRedirectToProfile(verifyFieldNames.addressDetailsStatus)
            return
        }
        setIsCertificateBtnLoading(false)
        toast.error(common.statusText.issueInUpdating)
    }

    const handleRedirectToProfile = (source: string) => {
        navigate("/profile", {
            state: {
                source: source,
                navInitFromTimeline: keyForCodeForSection.certificate,
                purchaseId: timelineDetails.purchaseId
            },
        });
    }

    const handleConfirmCertificateDelivered = () => {
        setCertificateErr("")
        handleOpenModal()
    }

    const handleOpenModal = () => {
        setShowModal(true)
    }
    const handleCloseModal = async (status: string) => {
        if (status === 'confirmCertificateDelivered') {
            // debugger
            setShowModal(false)
            setIsCertificateBtnLoading(true)
            setCertificateErr("")
            // return // testing
            const fieldsToUpdate = {
                purchaseId: timelineDetails.purchaseId
            }
            const markCertificateReceivedApiCallStatus = await markCertificateReceivedApiCall(fieldsToUpdate);
            if (markCertificateReceivedApiCallStatus.status) {
                // TODO update timelineDetails reducer
                // xxpx
                window.location.reload();
                console.log("TODO markCertificateReceivedApiCallStatus")
            } else {
                toast.error(common.statusText.issueInUpdating)
            }
            setTimeout(() => {
                setIsCertificateBtnLoading(false)
            }, 700)
        } else {
            setShowModal(false)
        }
    }


    const handleWhichUiToRender = () => {
        // series conition will come after : !timelineDetails.isEligibleForCertificate
        setRenderUi(certificateUI)
    }


    const ui = useMemo(() => {
        switch (renderUi) {
            case listOfUiForCertificates.inEligible:
                return <InEligibleNotice />;
            case listOfUiForCertificates.overDue:
                return <PaymentPendingNotice />;
            case listOfUiForCertificates.verificationPending:
                return <VerificationPending />;
            case listOfUiForCertificates.examPending:
                return <ExamPending />;
            case listOfUiForCertificates.extendDuration:
                return <ExtendDuration />;
            case listOfUiForCertificates.nocVerificationPending:
                return <NocVerificationPending />
            case listOfUiForCertificates.ready:
                return <CertificateReady
                    certificateErr={certificateErr}
                    isCertificateBtnLoading={isCertificateBtnLoading}
                    handleCertificateClaim={handleCertificateClaim}
                />;
            case listOfUiForCertificates.claimed:
                return <CertificateClaimed />;
            case listOfUiForCertificates.dispatch:
                return <CertificateDispatched
                    certificateErr={certificateErr}
                    isCertificateBtnLoading={isCertificateBtnLoading}
                    handleConfirmCertificateDelivered={handleConfirmCertificateDelivered}
                />;
            case listOfUiForCertificates.deliveryConfrimedAt:
                return <DeliveryConfirmed />;
            default:
                return <div className="message">Checking your certificate status. Please wait...</div>;
        }
    }, [renderUi, isCertificateBtnLoading, certificateErr]);

    return (
        <>
            <CertificateView
                timelineDetails={timelineDetails}
                renderUi={renderUi}
                ui={ui}
            />
            <ConfirmCertificateDeliveredModal
                show={showModal}
                handleClose={handleCloseModal}
            />
        </>
    );
};


